export default {
  eyebrow: '',
  heading: 'We are the total Experience Agency.',
  copy: 'We build experience ecosystems that build better business.',
  image: {
    alt: 'Image showing a person holding a pencil',
    filename:
      '//a.storyblok.com/f/46530/1480x833/7bdfb2f231/hero-total_experience.png',
  },
  video: {
    alt: 'Article Video',
    filename: null,
    temp: '//a.storyblok.com/f/46530/x/05859de4bd/hero-003-desk.mp4',
  },
  youtube: {
    url: 'https://www.youtube.com/watch?v=2CCNswShJRc',
    temp: 'https://www.youtube.com/watch?v=2CCNswShJRc',
  },
  vimeo: {
    url: '',
    temp: 'https://vimeo.com/343460749',
  },
  cta: [],
  component: 'o-hero-image',
}
